import { render, staticRenderFns } from "./UdefEventCardHorizontal.vue?vue&type=template&id=3ed2a907&scoped=true&"
import script from "./UdefEventCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./UdefEventCardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./UdefEventCardHorizontal.vue?vue&type=style&index=0&id=3ed2a907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2a907",
  null
  
)

export default component.exports